<div class="food-basket-card-container" [ngClass]="{ 'last-card': isLast }" *ngIf="food">
    <div class="food-basket-card">
        <div class="food-basket-info">
            <p class="food-basket-title" (click)="onFoodClicked(); $event.stopPropagation()">{{ food | fieldTranslate: 'title' }}</p>

            <!-- модификаторы -->
            <div class="food-basket-modificators" *ngIf="modificators" (click)="onFoodClicked(); $event.stopPropagation()">
                <div class="food-basket-modificator">
                    <p class="lowercase-text">{{ modificators.active ? (modificators | titleTranslate) : 'added' | translate }}:</p>
                    <div *ngFor="let item of modificators.items">
                        <div *ngIf="item.count > 0 && item.price as value">
                            <span>{{ item.count }} · {{ item | titleTranslate }} ·</span>
                            <ng-container *ngIf="item.count * item.price | priceSeparator as separated">
                                <span class="food-basket-modificator__whole">{{ separated.whole }}</span>
                                <span class="food-basket-modificator__dot">{{ separated.separator }}</span>
                                <span class="food-basket-modificator__fraction">{{ separated.fraction }}</span>
                                <span class="food-basket-modificator__currency">{{ locale?.currency }}</span>
                              </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <p class="food-basket-price" *ngIf="food.price as value">
                <ng-container *ngIf="value | priceSeparator as separated">
                    <span class="food-basket-price__whole">{{ separated.whole }}</span>
                    <span class="food-basket-price__dot">{{ separated.separator }}</span>
                    <span class="food-basket-price__fraction">{{ separated.fraction }}</span>
                    <span class="food-basket-price__currency">{{ locale?.currency }}</span>
                </ng-container>
                <span class="food-basket-variant" *ngIf="variant">{{ variant }}</span>
                <span class="food-basket-size" *ngIf="food.size">{{ localSize }} {{ locale?.units?.get(food.unit) }}</span>
            </p>
            <!-- Аллергены: свои и выбранных добавок -->
            <app-allergen-pill class="allergen-row" [plain]="true" [max]="14"
              [allergens]="food.allergens | allergensWithAddons: modificators"></app-allergen-pill>
            
            <!-- Блок управления количеством -->
            <div class="food-basket-counter">
                <button class="counter-button-dec" (click)="decrement(); $event.stopPropagation()">−</button>
                <span class="food-basket-counter__value">{{ food.count }}</span>
                <button class="counter-button-inc" (click)="increment(); $event.stopPropagation()">+</button>
            </div>
        </div>
        <div class="food-basket-image" (click)="onFoodClicked(); $event.stopPropagation()" *ngIf="food.image">
            <img [src]="imageSrc" alt="{{ food | fieldTranslate: 'title' }}" />
        </div>
    </div>
</div>